import React from 'react';
import { useTranslation } from 'react-i18next';

import { IAnnualReport } from '../../../../../../selfServicePortal/interfaces/i-api-creaditCard';

interface IMobileAnnualReport {
	data: IAnnualReport
}

const MobileAnnualReport = ({ data }: IMobileAnnualReport) => {
	const { t } = useTranslation()
	return (
		<div className="annual-report my-5">
			<div className="d-flex justify-content-between align-items-center mb-3">
				<h5>{t('AnnualReport')}</h5>
			</div>
			<div className="mobile-item d-flex justify-content-between py-3">
				<b>{t('Deposit')}</b>
				<div>{data.accountDebitBalance}</div>
			</div>
			<div className="mobile-item d-flex justify-content-between py-3">
				<b>{t('UsedCredit')}</b>
				<div>{data.accountCreditBalance}</div>
			</div>
			<div className="mobile-item d-flex justify-content-between py-3">
				<b>{t('RecieveInterest')}</b>
				<div>{data.interestReceived}</div>
			</div>
			<div className="mobile-item d-flex justify-content-between py-3">
				<b>{t('InterestPaid')}</b>
				<div>{data.interestPaid}</div>
			</div>
			<div className="mobile-item d-flex justify-content-between py-3">
				<b>{t('ValueDate')}</b>
				<div>{data.currency}</div>
			</div>
		</div>
	)
}

export default MobileAnnualReport;